import { Icon } from "../../icons";
import { OptionVisual } from "./OptionVisual";
import type { SelectOption } from "./selectOption";

interface SelectOptionItemProps {
  id: string;
  option: SelectOption;
  index: number;
  selected: boolean;
  active: boolean;
  onActivate: (index: number) => void;
  onCommit: (option: SelectOption) => void;
}

/** One option of the listbox; hovering highlights it and clicking selects it, without moving the focus. */
export function SelectOptionItem({ id, option, index, selected, active, onActivate, onCommit }: SelectOptionItemProps): React.JSX.Element {
  return (
    <li
      id={id}
      role="option"
      data-index={index}
      aria-selected={selected}
      aria-disabled={option.disabled || undefined}
      data-active={active || undefined}
      className="nb-select-option"
      onMouseDown={(e) => e.preventDefault()}
      onMouseMove={() => {
        if (!option.disabled && !active) onActivate(index);
      }}
      onClick={() => onCommit(option)}
    >
      <OptionVisual option={option} />
      <span className="nb-select-option-label">{option.label}</span>
      {option.hint ? <span className="nb-select-option-hint">{option.hint}</span> : null}
      <Icon name="check" className="nb-select-check" aria-hidden="true" />
    </li>
  );
}
